import { ContractStatusEnums } from "@lhd/types";

export const MENU_ITEM_IDS = {
  COMPANY_RULES: "company-rules",
} as const;

export const TOOLTIP_MESSAGES = {
  DEVELOPMENT: "拡張・工事中",
  NO_PERMISSION: "権限がありません。",
  NOT_PURCHASE: "購入無しのため使用不可",
  USER_RETIRED: "権限がありません。",
} as const;

export const CONTRACT_STATUS_ACCEPTED = [
  ContractStatusEnums.UN_CONTRACTED,
  ContractStatusEnums.TRIAL,
  ContractStatusEnums.OFFICIAL,
];

export const CONTRACT_STATUS_REJECTED_PAYMENT_REQUIRED = [
  ContractStatusEnums.TRIAL,
  ContractStatusEnums.OFFICIAL,
  ContractStatusEnums.CONTRACT_TERMINATED,
];
